export const STEP_VARIANT = {
  PERSONAL_INFORMATION: 'Personal Information',
  FIELDS_OF_ACTIVITY: 'Fields of activity',
  PROFFESSIONAL_ACADEMIC_DEGREES: 'Professional Knowledge',
  PROOF_OF_CODE_OF_CONDUCT: 'Proof of code of conduct',
  COMPANY_INFORMATION: 'Business Information',
  SUMMARY: 'Summary',
  PAYMENTS_CONFIRMATIONS: 'Conclusion',
  REQUEST_COMPANY_CHANGE: 'Change Type',
};
